export default __webpack_public_path__ + "static/media/pop_up.349e08f3.jpg";